module.exports = __webpack_public_path__ + "static/tall-cloud-131355f9f76303baa98d3341bd5e519d.png";